export class SignalSearchCriteria {
    name: string; // used if these search criteria are persisted as a saved search
    _id: string; // used if this search criteria has been save, id to allow delete
    
    categories: string[]; 
    tags: string[];
    emergency: boolean;
    status: string;
    urgency: string;
    mainCategory: string; 
    updateDateFrom: string; // in format YYYY-MM-DD
    updateDateTo: string; // in format YYYY-MM-DD
    publishDateFrom: string; // in format YYYY-MM-DD
    publishDateTo: string; // in format YYYY-MM-DD
    ref: string; // part of query search
    summary: string; // part of query search
    whatYouWillHear: string; // part of query search
    whatItMeans: string; // part of query search
    whatWeAreDoing: string; // part of query search
    whatYouShouldDo: string; // part of query search
    readMore: string; // part of query search
    ioc: string; // part of query search
    query: string; // will search any of the string fields noted above
    //iocCve: string; // available backend but not used frontend currently
    //iocIp: string; // available backend but not used frontend currently
    //iocDomain: string; // available backend but not used frontend currently
    //iocUrl: string; // available backend but not used frontend currently
    //iocEmail: string; // available backend but not used frontend currently
    //iocCpe: string; // available backend but not used frontend currently
    iocQuery: string; // will search all the above ioc fields
    returnStub: boolean; // return the basic attributes for summary screens
    count: boolean; // return count or the records
    limit: number;
    skip: number;
    sort: string;
    sortOrder: number
}

export class SignalLoadListCriteria {
    jiraRefs: string[];  // used to load flagged list in loadList end point
    returnStub: boolean; // return the basic attributes for summary screens
    count: boolean; // return count or the records
    limit: number;
    skip: number;
    sort: string;
    sortOrder: number;
}
export class SignalStatsCriteria {
    attributeName: string;
    publishDateFrom: string;
    publishDateTo: string;
}
export class VulnVendorSearchCriteria {
    vendor: string; // will search as a like
    limit: number;
    skip: number;
    sort: string;
    sortOrder: number;
    count: boolean; // return count or the records
    typeahead: boolean; // search begins with, or anywhere
}

export class VulnProductSearchCriteria {
    product: string; // will search as a like
    vendor: string; // will search as a fixed string
    limit: number;
    skip: number;
    sort: string;
    sortOrder: number;
    count: boolean; // return count or the records
    typeahead: boolean; // search begins with, or anywhere
}

export class VulnSearchCriteria {
    name: string; // used if these search criteria are persisted as a saved search
    _id: string; // used if this search criteria has been save, id to allow delete

    cveRefs: string[]; // used to load flagged list in loadList end point
    products: string[]; // used to load watched list in loadProductList end point
    cve: string;
    cwe: string;
    cpe: string;
    refSource: string;
    refName: string;
    product: string;
    vendor: string;
    severity: string;
    description: string;
    pubDateFrom: string; // in format YYYY-MM-DD
    pubDateTo: string; // in format YYYY-MM-DD
    modDateFrom: string; // in format YYYY-MM-DD
    modDateTo: string; // in format YYYY-MM-DD
    limit: number;
    skip: number;
    sort: string;
    sortOrder: number;
    count: boolean; // return count or the records
    returnStub: boolean; // return subset for list view
}

export class VulnSeverityStatsCriteria {
    pubDateFrom: string; // in format YYYY-MM-DD
    pubDateTo: string; // in format YYYY-MM-DD
    attributeName: string; // attribute
}

export class UserPreferenceArrayUpdateCriteria {
    topLevelObject: string; // allows arrayName to be a child, not required. If not specified arrayName at top level
    arrayName: string;
    item: any; // object, if updating existing requires an _id attribute
    delete: boolean // are we deleting
}

export class SupportCaseSearchCriteria {
    name: string; // used if these search criteria are persisted as a saved search
    _id: string; // used if this search criteria has been save, id to allow delete 
    caseRefs: string[]; // used to load flagged list in loadList end point

    caseNumber: string; 
    description: string;     
    createdFrom: string;
    createdTo: string;
    updatedFrom: string;
    updatedTo: string;
    closedDateFrom: string;
    closedDateTo: string;
    asset: string;
    assetId: string;
    type: string;
    category: string;
    priority: string;
    subject: string;
    status: string;
    contact: string;
    contactEmail: string;

    limit: number;
    skip: number;
    count: boolean //TODO can this even be implemented?
    sort: string;
    sortBy: string;
    returnStub: boolean; 
}
